import { render, staticRenderFns } from "./LoadlistSummary.vue?vue&type=template&id=458c3a20"
import script from "./LoadlistSummary.vue?vue&type=script&lang=ts"
export * from "./LoadlistSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports